<template>
    <router-link :to="item.url ? item.url : '/'">
        {{item.title}}
    </router-link>
    <el-icon v-if="item.submenu && toggleMenu==false" @click="toggleMenu=!toggleMenu" class="dropdown-menu-icon"><ArrowDown /></el-icon>
    <el-icon v-if="item.submenu && toggleMenu==true" @click="toggleMenu=!toggleMenu" class="dropdown-menu-icon"><ArrowUp /></el-icon>
    <ul v-if="item.submenu" class="dropdown-menu-item" :class="toggleMenu == true ? 'active-menu' : '' ">
        <li v-for="(sitem, index) in item.submenu" :key="index">
            <router-link :to="sitem.url">
                {{sitem.title}}
            </router-link>
        </li>
    </ul>
</template>

<script>
import { ArrowDown, ArrowUp } from '@element-plus/icons-vue'

export default {
    name: 'MenuItem',
    props: ['item'],
    components: {
        ArrowDown,
        ArrowUp
    },
    data() {
        return {
            toggleMenu: false
        }
    }
}
</script>